import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  paper: {
    margin: '0px',
    width: 'auto',
    display: 'flex',
    flex: 1,
  },
  indicator: {
    left: 0,
    backgroundColor: theme.evPalette.ocean[600],
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  tabElement: {
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRight: `1px solid ${theme.evPalette.charcoal[300]}`,
    textTransform: 'none',
    flex: 1,
    '&>.myev-MuiTab-wrapper': {
      alignItems: 'flex-start',
    },
    '&.Mui-selected': {
      borderRight: '0px',
      color: theme.evPalette.ocean[700],
    },
    '&:hover': {
      backgroundColor: theme.evPalette.ocean[100],
    },
    '@media (max-width: 640px)': {
      borderRight: '0px',
      maxWidth: '100%',
    },
  },
  filtersRow: {
    backgroundColor: theme.evPalette.charcoal[100],
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '8px',
    padding: '16px',
    '@media (min-width: 1024px)': {
      padding: '16px',
      alignItems: 'center',
      textWrap: 'nowrap',
      flexDirection: 'row',
    },
  },
  filtersSection: {
    display: 'flex',
    gap: '8px',
    flexDirection: 'column',
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
    },
  },
  filtersContainer: {
    display: 'flex',
    gap: '8px',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      width: '100%',
    },
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  searchRow: {
    padding: '8px',
    minHeight: '112px',
    '&>*': { height: '44px' },
    '& button': {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '19px',
      textTransform: 'none',
    },
    '@media (min-width: 1024px)': {
      padding: '24px 24px 16px 24px',
      minHeight: '0px',
      borderBottom: `1px solid ${theme.evPalette.charcoal[200]}`,
    },
  },
  searchContainer: {
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '@media (min-width: 1024px)': {
      flexDirection: 'row-reverse',
      minWidth: ({ loading }) => (loading ? '30%' : 0),
    },
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    marginLeft: '0px',
    width: '100%',
    '@media (min-width: 1024px)': {
      width: 'fit-content',
    },
  },
  searchInput: {
    height: '44px',
    borderColor: theme.evPalette.charcoal[500],
    backgroundColor: theme.evPalette.salt[100],
    '@media (min-width: 1024px)': { width: '260px' },
  },
}));
